<template>
	<div class="fc-account-info">
		<label>My Information</label>
		<div>
			<div class="fc-account-detail">
				<label>Account Details</label>
				<div>
					<label>FULL NAME</label>
					<span>{{ info.FullName }}</span>
				</div>
				<div>
					<label>EMAIL ADDRESS</label>
					<span>{{ info.Email }}</span>
				</div>
				<div>
					<label>MOBILE NO.</label>
					<span>{{ info.ContacctNo }}</span>
				</div>
				<div class="fc-control">
					<a @click="editDetail">Edit my details</a>
					<a @click="changePassword">Change password</a>
				</div>
			</div>
			<div class="fc-address-list">
				<div class="fc-default-address" v-if="defaultAddress != null">
					<label>Default Address</label>
					<div>
						{{ defaultAddress.FullName }}<br />
						{{ defaultAddress.MobileNo }}<br /><br />

						{{ defaultAddress.Address }}<br />
						#{{ defaultAddress.UnitNo }}<br />
						Singapore {{ defaultAddress.PostalCode }}
					</div>
					<a @click="editAddress(defaultAddress)">Edit</a>
				</div>
				<div class="fc-address-item" v-if="additionAddress.length > 0">
					<label>Additional Address</label>
					<div class="fc-address" v-for="add in additionAddress">
						<div>
							{{ add.FullName }}<br />
							{{ add.MobileNo }}<br /><br />

							{{ add.Address }}<br />
							#{{ add.UnitNo }}<br />
							Singapore {{ add.PostalCode }}
						</div>
						<div class="fc-control">
							<a @click="editAddress(add)">Edit</a>
							<span>|</span>
							<a @click="deleteAddress(add.CustomersAddressId)">Delete</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapMultiRowFields } from 'vuex-map-fields'
import $ from 'jquery'
export default {
  name: 'ProfileInfo',
  created () {
    this.$store.dispatch('customer/getAddressList')
  },
  methods: {
    editDetail () {
      this.$emit('editDetail')
    },
    changePassword () {
      this.$emit('changePassword')
    },
    editAddress: function (address) {
      this.$emit('editAddress', address)
    },
    deleteAddress (id) {
      const _this = this
      const d = {
        CustomersAddressId: id
      }
      if (process.browser) {
        $.confirm({
          title: 'Warning',
          content: 'Remove this address?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function () {
                _this.$store.dispatch('customer/removeAddress', d)
              }
            },
            close: function () {
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters('customer', ['info']),
    ...mapMultiRowFields('customer', {
      addressList: 'addressList'
    }),
    defaultAddress () {
      return this.addressList.filter(a => a.IsDefault)[0]
    },
    additionAddress () {
      return this.addressList.filter(a => a.IsDefault === false)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile/Info.vue